import { createStore, combineReducers, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { userPreferencesReducer } from "./user-preferences/reducers";
import { studyDataReducer } from "./study-data/reducers";
import { groupsBuddiesDataReducer } from "./groups-buddies-data/reducers";
import { tasksReducer } from "./tasks/reducers";

const rootReducer = combineReducers({
  userPreferences: userPreferencesReducer,
  studyData: studyDataReducer,
  groupsBuddiesData: groupsBuddiesDataReducer,
  tasks: tasksReducer,
});

export default function configureStore() {
  const middlewares = [thunkMiddleware];
  const middleWareEnhancer = applyMiddleware(...middlewares);

  const store = createStore(
    rootReducer,
    composeWithDevTools(middleWareEnhancer)
  );

  return store;
}
